<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <label>From Date</label>
        <input type="date" [(ngModel)]="selected_from_date" (ngModelChange)="changeEvent()" class="main-border-class">
      </div>
      <div class="col-4">
        <label>To Date</label>
        <input type="date" [(ngModel)]="selected_to_date" [min]="selected_from_date" (ngModelChange)="changeEvent()"
          class="main-border-class">
      </div>
    </div><br>
    <div class="row">
      <div class="col-4">
        <mat-label>Select Shift</mat-label>
        <mat-select [(ngModel)]="selected_session" (ngModelChange)="changeEvent()" class="main-border-class">
          <mat-option [value]="session.id" *ngFor="let session of session_list">{{session['name']}}</mat-option>
          <mat-option value="all">Morning + Evening</mat-option>
        </mat-select>
      </div>
    </div><br>
    <div class="row">
      <div class="col-4">
        <mat-label>Report Option</mat-label>
        <mat-select [(ngModel)]="selected_report_option" (ngModelChange)="changeEvent()" class="main-border-class">
          <mat-option value="zone">Zone Wise</mat-option>
          <mat-option value="zone_wise_booth">Zone Wise Booth</mat-option>
          <mat-option value="route">Route Wise</mat-option>
          <mat-option value="booth">Booth Wise</mat-option>
        </mat-select>
      </div>
      <div class="col-4">
        <mat-label>Sale Option</mat-label>
        <mat-select [(ngModel)]="selected_sale_type" (ngModelChange)="changeEvent()" class="main-border-class"
          (valueChange)="saleOptionChanged($event)">
          <mat-option value="cash">Cash</mat-option>
          <mat-option value="card">Card</mat-option>
          <mat-option value="both">Cash + Card</mat-option>
        </mat-select>
      </div>
      <div class="col-4" style="margin-top: 3%;">
        <mat-checkbox [(ngModel)]="is_leakage_included" (ngModelChange)="changeEvent()" [disabled]="disable_checkbox">
          <label style="font-size: 20px;">Leakage</label></mat-checkbox>
      </div>
    </div><br>
    <div class="row">
      <div class="col">
        <table style="border-collapse: collapse; border: none;">
          <tr style="background: lightgray;">
            <th>Total</th>
            <th>TM</th>
            <th>SM</th>
            <th>COW</th>
            <th>FCM</th>
            <th>TMATE</th>
            <th>Curd</th>
            <th>Butter Milk</th>
            <th>Lassi</th>
            <th>SGM 450</th>

          </tr>
          <tr>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'milk_litre')">Total Milk Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tm_litre')">Total TM Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'sm_litre')">Total SM Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow_litre')">Total COW Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fcm_litre')">Total FCM Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tea_litre')">Total TMATE Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd_kgs')">Total Curd Kgs</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'buttermilk_litre')">Total Butter Milk Litre
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'lassi_litre')">Total lassi Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'sgm450_litre')">Total SGM450 Litre</mat-checkbox>
            </td>
          </tr>
          <tr>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'milk_cost')">Total Milk Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tm_cost')">Total TM Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'sm_cost')">Total SM Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow_cost')">Total COW Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fcm_cost')">Total FCM Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tea_cost')">Total TMATE Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd_cost')">Total Curd Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'buttermilk_cost')">Total Butter Milk Cost
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'lassi_cost')">Total lassi Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'sgm450_cost')">Total SGM450 Cost</mat-checkbox>
            </td>
          </tr>
          <tr>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fermented_products_litre')">Total Fermented Litre
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tm500_litre')">TM 500 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'std500_litre')">SM 500 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow500_litre')">COW 500 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fcm1000_litre')">FCM 1000 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tea1000_litre')">TMATE 1000 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd500_kgs')">Curd 500 Kgs</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd5000_kgs')">Curd 5000 Kgs</mat-checkbox>
            </td>
            <!-- <td>
              <mat-checkbox (change)="productValueChanged($event, 'buttermilk200_litre')">Butter Milk Litre
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'lassi200_kgs')">Lassi Kgs</mat-checkbox>
            </td> -->
          </tr>
          <tr>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fermented_products_cost')">Total Fermented Cost
              </mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tm500_cost')">TM 500 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'std500_cost')">SM 500 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow500_cost')">COW 500 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fcm1000_cost')">FCM 1000 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tea1000_cost')">TMATE 1000 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd500_cost')">Curd 500 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd5000_cost')">Curd 5000 Cost</mat-checkbox>
            </td>
            <td>
              <!-- <mat-checkbox (change)="productValueChanged($event, 'buttermilk200_cost')">Butter Milk Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'lassi200_cost')">Lassi Cost</mat-checkbox>
            </td> -->
          </tr>
          <tr>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'total_litre')">Total Litre</mat-checkbox>
            </td>
            <td>
              <!-- <mat-checkbox (change)="productValueChanged($event, 'tmcan_litre')">TM Can Litre</mat-checkbox> -->
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'std250_litre')">SM 250 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow250_litre')">COW 250 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow200_litre')">COW 200 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fcm500_litre')">FCM 500 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tea500_litre')">TMATE 500 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd150_kgs')">Curd 150 Kgs</mat-checkbox>
            </td>
            <td></td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'sgm450_litre')">SGM450 Litre</mat-checkbox>
            </td>
          </tr>
          <tr>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'total_cost')">Total Cost</mat-checkbox>
            </td>
            <td>
              <!-- <mat-checkbox (change)="productValueChanged($event, 'tmcan_cost')">TM Can Cost</mat-checkbox> -->
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'std250_cost')">SM 250 Litre</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow250_cost')">COW 250 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cow200_cost')">COW 200 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'fcm500_cost')">FCM 500 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'tea500_cost')">TMATE 500 Cost</mat-checkbox>
            </td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'curd150_cost')">Curd 150 Cost</mat-checkbox>
            </td>
            <td></td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'sgm450_cost')">SGM450 Cost</mat-checkbox>
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cupcurd_kgs')">Cup Curd Kgs</mat-checkbox>
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <mat-checkbox (change)="productValueChanged($event, 'cupcurd_cost')">Cup Curd Cost</mat-checkbox>
            </td>
          </tr>
        </table>
      </div>
    </div><br>
    <div class="row">
      <div class="col-4" style="text-align: center;">
        <button mat-button class="button-class" [disabled]="checkDisabled()" (click)="getClicked()">Get</button>
      </div>
      <div class="col-4" *ngIf="!is_document_available">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="50">
        </mat-progress-spinner>
      </div>
      <div class="col-4" *ngIf="document_file!== null && is_document_available">
        <button mat-button class="button-class" (click)="downloadClicked()"><i class="material-icons">
            get_app
          </i> Download Excel</button>
      </div>
    </div><br><br><br>
  </div>
</section>